import { createContext } from 'react';

type VendorQualificationsProps = {
  recaptchaRef: React.MutableRefObject<any>;
};

export default createContext<Partial<VendorQualificationsProps>>({
  recaptchaRef: null,
});
